import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { urlServer } from '../global_constants';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  token:any;
  //REF NEW SALE VARIABLES
  notifsCaSubject:Subject<any>;
  pathApiNotifs:string="/v1/notifications";
  urlRequestNotifsCa: string =urlServer.concat(this.pathApiNotifs).concat("/ca");

  constructor(private httpClient: HttpClient) {
    this.notifsCaSubject = new Subject();
    if(localStorage.getItem("token")!=null && localStorage.getItem("token")!=undefined) 
      this.token = localStorage.getItem("token")
    else this.token = sessionStorage.getItem("token")
   }

  getNotificationsCA(){
    let header: HttpHeaders = new HttpHeaders();
    header = header.set('authorization', "Bearer "+this.token );
    return  this.httpClient.get<any>(this.urlRequestNotifsCa,{headers: header});
  }
}
